import { Box } from "@mui/material";
import Text from "../../../../../components/ui/Text";

export const InfoBlock = ({ title, description, icon }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "90px",
          height: "90px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          backgroundColor: "#162456",
          mb: 2,
        }}
      >
        {icon}
      </Box>
      <Text variant="subtitle2" sx={{ color: "#171717", fontSize: "16px" }}>
        {title}
      </Text>
      <Text variant="paragraph" sx={{ color: "#171717", fontSize: "16px" }}>
        {description}
      </Text>
    </Box>
  );
};
